"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaStagingStation = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const Units_1 = require("../../Units");
const MoonCard_1 = require("./MoonCard");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
class LunaStagingStation extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.LUNA_STAGING_STATION,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.BUILDING],
            cost: 12,
            reserveUnits: Units_1.Units.of({ titanium: 1 }),
            tr: { moonLogistics: 2 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.logisticRate(2)),
            metadata: {
                description: 'Requires Logistic Rate to be 2 or higher. Spend 1 titanium. Raise the Logistic Rate 2 steps.',
                cardNumber: 'M30',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().titanium(1);
                    b.moonLogisticsRate({ amount: 2 });
                }),
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, true, false, false, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        super.play(player);
        MoonExpansion_1.MoonExpansion.raiseLogisticRate(player, 2);
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, moonLogisticsRateIncrease: 2, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.LunaStagingStation = LunaStagingStation;
//# sourceMappingURL=LunaStagingStation.js.map